import { Card, Col, Row } from "antd";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import AppStore, { TagItem } from "../../../stores/User/AppStore";
import CardBox from "./CardBox";
import styles from "./index.module.scss";
import AuthStore from "../../../stores/AuthStore";

export interface CardListProps {}

const CardList: React.FC<CardListProps> = (props) => {
  const { projects, otherTag, versionTypeCur } = AppStore;

  return (
    <div className={styles.site_card_list_wrapper}>
      {projects
        .filter(
          (item) =>
            item.otherTag?.includes(versionTypeCur.toString())
        )
        .map((project, idx) => (
          <CardBox project={project} key={idx} />
        ))}

      <div className={styles.version_type_left}>
        {otherTag.map((item: TagItem, index: number) => (
          <span
            className={versionTypeCur === item.id ? styles.active : ""}
            onClick={() => {
              AppStore.setVersionTypeCur(item.id);
              AppStore.getAppPictureList();
            }}
            key={item.id}
          >
            {item.name}
          </span>
        ))}
      </div>
    </div>
  );
};

export default observer(CardList);
